import React from 'react';
import { Row, Col, Media } from 'react-bootstrap';
import LoadingPlaceholder from './../../shared/LoadingPlaceholder';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyWeather } from './../../../actions';

import isEmpty from 'lodash/isEmpty';
import keys from 'lodash/keys';
import sortBy from 'lodash/sortBy';
import startsWith from 'lodash/startsWith';
import moment from 'moment';

import './weather.scss';

class Weather extends React.Component {

  constructor(props) {
    super(props);

    this.todayWeather = this.todayWeather.bind(this);
    this.additionalDaysWeatherData = this.additionalDaysWeatherData.bind(this);
  }

  componentWillMount() {
    this.props.actions.customerJourneyWeather(this.props.token, this.props.currentLanguage, this.props.context);
  }

  todayWeather() {
    let dates = sortBy(keys(this.props.weather.apiData));
    return this.props.weather.apiData[dates[0]] || {};
  }

  additionalDaysWeatherData() {
    let dates = sortBy(keys(this.props.weather.apiData)).slice(1);
    return dates.map((date, index) => {
      return(
        <div key={index} className={`shared-weather-component__weather-card text-center ${index > 2 ? 'hidden-xs' : null}`}>
          <div><img width={55} src={this.props.weather.apiData[date].image} alt={this.props.weather.apiData[date].desc} /></div>
          <h3 className="shared-weather-component__weather-card-date">{moment(date).format('D/M')}</h3>
          <h4 className="shared-weather-component__weather-card-temp">{`${Math.round(this.props.weather.apiData[date].t_max) || '-'}°`}</h4>
        </div>
      );
      /*
      return {
        image: this.props.weather.apiData[date].image,
        date: moment(date).format('M/D'),
        temp: `${Math.round(this.props.weather.apiData[date].t_max) || '-'}°`
      };
      */
    });
  }

  render() {

    if(isEmpty(this.props.weather.apiData) && !this.props.weather.loading) return null;

    const weatherDesc = startsWith(this.props.translate(`shared.weather.${this.todayWeather().desc}`), 'Missing') ? this.props.translate(`shared.weather.default`) : this.props.translate(`shared.weather.${this.todayWeather().desc}`) ;
    const weatherMinMax = `${Math.round(this.todayWeather().t_min) || '-'}°/${Math.round(this.todayWeather().t_max) || '-'}°`;

    const additionalDaysWeather = this.props.weather

    return (
      <Row className="shared-weather-component">
        <Col md={4} mdOffset={4} sm={6} smOffset={3} xs={12}>
        <Media>
          <Media.Left align="middle">
            <LoadingPlaceholder ready={!this.props.weather.loading}>
              <img width={90} src={this.todayWeather().image} alt={this.todayWeather().desc} />
            </LoadingPlaceholder>
          </Media.Left>
          <Media.Body>
            <h2 className="media-heading text-center"><strong><LoadingPlaceholder ready={!this.props.hotel.loading}><span>{(this.props.hotel.apiData || {}).city}</span></LoadingPlaceholder></strong></h2>
            <h4 className="text-center">
              <LoadingPlaceholder ready={!this.props.weather.loading}>{weatherDesc}</LoadingPlaceholder>
            </h4>
          </Media.Body>
          <Media.Right align="bottom">
            <h3 className="shared-weather-component__today-min-max">{weatherMinMax}</h3>
          </Media.Right>
        </Media>
        </Col>
        <Col xs={12} className="text-center">
          <br/>
          {this.additionalDaysWeatherData()}
        </Col>
      </Row>
    );
  }
}

Weather.displayName = 'PagesSharedWeather';
Weather.propTypes = {};
Weather.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    token: state.commons.token,
    context: state.commons.context,
    hotel: state.hotel,
    weather: state.weather
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyWeather: bindActionCreators(customerJourneyWeather, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Weather);



// WEBPACK FOOTER //
// ./components/pages/shared/Weather.js